export default __webpack_public_path__ + "static/desktop-ed13447f72b51916cd485ed717fb094b.jpg";